import { d as h, b as bem } from './p-c44c2366.js';

const generateClassNames = bem('cosmos-live-icon-animated');
const CosmosLiveIconAnimated = ({ class: classname, slot, }) => {
    return (h("div", { class: [generateClassNames(), classname].join(' '), slot: slot },
        h("div", { class: generateClassNames('dot') })));
};

export { CosmosLiveIconAnimated as C };
